import axios from 'axios';
import * as functions from './functions';
import * as environment from '../environment/environment';

class HttpService {
  constructor() {
    axios.defaults.baseURL = environment.BASE_URL;
    axios.interceptors.request.use(
        (config) => config, (error) => {
          functions.errorHandler(error);
          return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error.response && error.response.data && error.response.data.status === 401) {
            window.location.replace(`${environment.BASE_URL}/login`);
          }
          if (!axios.isCancel(error)) {
            functions.errorHandler(error);
          }
          return Promise.reject(error);
        }
    );
  }

  get(url, config) {
    return axios.get(url, config);
  }

  post(url, data, config) {
    config = config || { headers: { 'content-type': 'application/json' }};
    return axios.post(url, data, config);
  }

  put(url, data, config) {
    config = config || { headers: { 'content-type': 'application/json' }};
    return axios.put(url, data, config);
  }

  delete(url, data, config) {
    config = config || { headers: { 'content-type': 'application/json' }};
    return axios.delete(url, config);
  }
}

export default new HttpService();
